import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/app/store";
import { transformObject } from "../redux/types/TypeHelper";

export const useAppSelector: TypedUseSelectorHook<RootState> = (selector) => {
  const selectedState = useSelector(selector);

  if (selector.toString().includes("cartAndLoyaltyReducer")) {
    return transformObject(selectedState);
  }

  return selectedState;
};

export const useAppDispatch = () => useDispatch<AppDispatch>();

// export function useTraceRerender(props: any, state: any, selectors: any) {
//   const prevProps = useRef(props);
//   const prevState = useRef(state);
//   const prevSelectors = useRef(selectors);

//   useEffect(() => {
//     // Track prop changes
//     Object.entries(props).forEach(([key, val]) => {
//       if (prevProps.current[key] !== val) {
//         console.log(
//           `Prop '${key}' changed from`,
//           prevProps.current[key],
//           "to",
//           val
//         );
//       }
//     });

//     // Track state changes
//     Object.entries(state).forEach(([key, val]) => {
//       if (prevState.current[key] !== val) {
//         console.log(
//           `State '${key}' changed from`,
//           prevState.current[key],
//           "to",
//           val
//         );
//       }
//     });

//     // Track selector changes
//     Object.entries(selectors).forEach(([key, val]) => {
//       if (prevSelectors.current[key] !== val) {
//         console.log(
//           `Selector '${key}' changed from`,
//           prevSelectors.current[key],
//           "to",
//           val
//         );
//       }
//     });

//     // Update previous values
//     prevProps.current = props;
//     prevState.current = state;
//     prevSelectors.current = selectors;
//   });
// }
